module.exports = __webpack_public_path__ + "img/__icon_LAWETA.1ba03e58.svg";